<template>
  <el-form
    :model="userForm"
    :rules="rules"
    ref="userForm"
    label-position="left"
    label-width="0px"
    v-loading="loading"
  >
    <el-form-item prop="orgnizationId" v-if="type != 'changePassword' && type != 'resetPassword'">
      <el-select
        v-model="userForm.orgnization.id"
        filterable
        placeholder="请选择组织"
        style="width: 100%;"
      >
        <el-option
          v-for="item in orgnizations"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="roleId" v-if="type != 'changePassword' && type != 'resetPassword'">
      <el-select
        v-model="userForm.role.id"
        filterable
        placeholder="请选择角色"
        style="width: 100%;"
      >
        <el-option
          v-for="item in roles"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="username" v-if="type != 'changePassword'">
      <el-input
        type="text"
        v-model="userForm.username"
        autocomplete="off"
        placeholder="账号"
      ></el-input>
    </el-form-item>
    <el-form-item prop="curPassword" v-if="type === 'changePassword' || type === 'resetPassword'">
      <el-input
        type="password"
        v-model="userForm.curPassword"
        autocomplete="off"
        placeholder="当前密码"
      ></el-input>
    </el-form-item>
    <el-form-item prop="password" v-if="type != 'edit'">
      <el-input
        type="password"
        v-model="userForm.password"
        autocomplete="off"
        :placeholder="type === 'changePassword' ? '新密码' : '密码'"
      ></el-input>
    </el-form-item>
    <el-form-item prop="checkPassword" v-if="type != 'edit'">
      <el-input
        type="password"
        v-model="userForm.checkPassword"
        autocomplete="off"
        :placeholder="type === 'changePassword' ? '确认新密码' : '确认密码'"
      ></el-input>
    </el-form-item>
    <el-form-item prop="nickName" v-if="type != 'changePassword' && type != 'resetPassword'">
      <el-input
        type="text"
        v-model="userForm.nickName"
        autocomplete="off"
        placeholder="昵称"
      ></el-input>
    </el-form-item>
    <el-form-item v-if="type == 'register'">
      <el-button
        type="primary"
        style="width: 100%;border: none"
        v-on:click="register('userForm')"
        >注册</el-button
      >
    </el-form-item>
    <el-form-item v-if="type == 'edit'">
      <el-button
        type="primary"
        style="width: 100%;border: none"
        v-on:click="edit('userForm')"
        >更新</el-button
      >
    </el-form-item>
    <el-form-item v-if="type == 'changePassword'">
      <el-button
        type="primary"
        style="width: 100%;border: none"
        v-on:click="changePassword('userForm')"
        >修改密码</el-button
      >
    </el-form-item>
    <el-form-item v-if="type == 'resetPassword'">
      <el-button
        type="primary"
        style="width: 100%;border: none"
        v-on:click="resetPassword('userForm')"
        >重置密码</el-button
      >
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    orgnizations: {
      type: Array,
      default: () => []
    },
    roles: {
      type: Array,
      default: () => []
    },
    userForm: {
      username: '',
      nickName: '',
      role: {},
      orgnization: {},
      curPassword: '',
      password: '',
      checkPassword: ''
    },
    rules: {}
  },

  data () {
    return {
      loading: false
    }
  },

  computed: {

  },

  mounted () {

  },

  methods: {
    register (formName) {
      var _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$data.loading = true
          this.postRequest('/register', _this.userForm)
            .then(resp => {
              this.$data.loading = false
              if (resp && resp.code === 200) {
                _this.$router.replace('/users')
              }
            })
        }
      })
    },

    resetPassword (formName) {
      var _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$data.loading = true
          this.postRequest('/reset_password', _this.userForm)
            .then(resp => {
              this.$data.loading = false
              if (resp && resp.code === 200) {
                _this.$message.success({ message: '修改成功' })
                _this.$set(_this.userForm, 'curPassword', '')
                _this.$set(_this.userForm, 'password', '')
                _this.$set(_this.userForm, 'checkPassword', '')
              }
            })
        }
      })
    },

    changePassword (formName) {
      var _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$data.loading = true
          this.postRequest('/changePassword', _this.userForm)
            .then(resp => {
              this.$data.loading = false
              if (resp && resp.code === 200) {
                _this.$message.success({ message: '修改成功' })
                _this.$set(_this.userForm, 'curPassword', '')
                _this.$set(_this.userForm, 'password', '')
                _this.$set(_this.userForm, 'checkPassword', '')
              }
            })
        }
      })
    },

    edit (formName) {
      var _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$data.loading = true
          this.putRequest('/user_update', _this.userForm)
            .then(resp => {
              this.$data.loading = false
              if (resp && resp.code === 200) {
                _this.$message.success({ message: '更新成功' })
                // _this.$router.replace('/users')
              }
            })
        }
      })
    }
  }
}
</script>
<style></style>
